
  import {prepareImageUrl} from '@/helper/ImageHelper';
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    name: 'JoblistingCta',
    components: {
      RegistrationOrLoginDialog: () =>
        import('@/components/candidate/RegistrationOrLoginDialog'),
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [ScreenSize],
    props: {
      cta: {
        type: Object,
        required: false,
        default: () => {},
      },
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey(props) {
      // Deaktiviere das Caching, wenn der Benutzer eingeloggt ist
      if (props.loggedIn) {
        return false;
      }

      // Ansonsten generiere einen eindeutigen Cache-Schlüssel
      return 'joblisting-cta-' + props.section.id;
    },
    data() {
      return {
        imageUrl: process.env.NUXT_ENV_FALLBACK_CARD_IMAGE,
        imageUrlNxt: process.env.NUXT_ENV_FALLBACK_CARD_IMAGE_STATIC,
      };
    },
    created() {
      if (this.cta.image) {
        this.imageUrl = prepareImageUrl(this.cta.image.url);
        this.imageUrlNxt = prepareImageUrl(this.cta.image.url);
      }
    },
  };
